import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "incident-details-container" }
const _hoisted_2 = { class: "incident-details-header" }
const _hoisted_3 = { class: "ms-auto d-flex gap-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "incident-meta-card" }
const _hoisted_7 = { class: "incident-title" }
const _hoisted_8 = { class: "incident-meta-row" }
const _hoisted_9 = { class: "incident-status-label" }
const _hoisted_10 = { value: "open" }
const _hoisted_11 = { value: "investigating" }
const _hoisted_12 = { value: "resolved" }
const _hoisted_13 = { value: "closed" }
const _hoisted_14 = { class: "incident-date" }
const _hoisted_15 = { class: "incident-description-card" }
const _hoisted_16 = { class: "incident-description-label" }
const _hoisted_17 = { class: "incident-description-content" }
const _hoisted_18 = { class: "incident-entries-header" }
const _hoisted_19 = { class: "incident-entries-feed" }
const _hoisted_20 = { class: "incident-entry-header" }
const _hoisted_21 = { class: "incident-entry-author" }
const _hoisted_22 = { class: "incident-entry-date" }
const _hoisted_23 = { style: {"margin-left":"auto","display":"flex","gap":"0.5rem"} }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 1,
  class: "incident-entry-edit-form"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-outline-secondary mb-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      }, _toDisplayString(_ctx.$t('panel.incidents.detail.back')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-outline-secondary mb-3 download-md-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadMarkdown && _ctx.downloadMarkdown(...args)))
        }, _toDisplayString(_ctx.$t('panel.incidents.detail.downloadMarkdown')), 1),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary mb-3 download-md-btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadPostmortem && _ctx.downloadPostmortem(...args))),
          disabled: _ctx.isDownloadingPostmortem
        }, [
          (_ctx.isDownloadingPostmortem)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.isDownloadingPostmortem ? _ctx.$t('panel.incidents.detail.generating') : _ctx.$t('panel.incidents.detail.downloadPostmortem')), 1)
        ], 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.incident.title), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('panel.incidents.statusLabel')), 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statusUpdate) = $event)),
            class: "form-select d-inline w-auto ms-2 incident-status-select"
          }, [
            _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('panel.incidents.status.open')), 1),
            _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('panel.incidents.status.investigating')), 1),
            _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('panel.incidents.status.resolved')), 1),
            _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('panel.incidents.status.closed')), 1)
          ], 512), [
            [_vModelSelect, _ctx.statusUpdate]
          ]),
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary ms-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateStatus && _ctx.updateStatus(...args)))
          }, _toDisplayString(_ctx.$t('panel.incidents.update')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('panel.incidents.detail.created', { date: _ctx.formatDate(_ctx.incident.createdAt) })), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('panel.incidents.description')), 1),
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.incident.description), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('panel.incidents.detail.entries')), 1),
      _createElementVNode("button", {
        class: "btn btn-primary btn-sm",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEntryModal = true))
      }, _toDisplayString(_ctx.$t('panel.incidents.addEntry')), 1)
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedEntries, (entry) => {
        return (_openBlock(), _createElementBlock("div", {
          key: entry.id,
          class: "incident-entry-card"
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(entry.author), 1),
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatDate(entry.createdAt)), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                onClick: ($event: any) => (_ctx.startEditEntry(entry))
              }, _toDisplayString(_ctx.$t('panel.incidents.detail.edit')), 9, _hoisted_24),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger",
                onClick: ($event: any) => (_ctx.deleteEntry(entry))
              }, _toDisplayString(_ctx.$t('panel.incidents.detail.delete')), 9, _hoisted_25)
            ])
          ]),
          (_ctx.editingEntryId !== entry.id)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "incident-entry-message",
                innerHTML: _ctx.linkify(entry.message)
              }, null, 8, _hoisted_26))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingEntryMessage) = $event)),
                  class: "form-control mb-2"
                }, null, 512), [
                  [_vModelText, _ctx.editingEntryMessage]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary btn-sm me-2",
                  onClick: ($event: any) => (_ctx.saveEditEntry(entry))
                }, _toDisplayString(_ctx.$t('panel.incidents.detail.save')), 9, _hoisted_28),
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary btn-sm",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelEditEntry && _ctx.cancelEditEntry(...args)))
                }, _toDisplayString(_ctx.$t('panel.incidents.cancel')), 1)
              ]))
        ]))
      }), 128))
    ]),
    _createVNode(_component_BaseModal, {
      show: _ctx.showEntryModal,
      size: "sm",
      "content-class": "incident-modal-content",
      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showEntryModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('panel.incidents.addEntry')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newEntry.author) = $event)),
          class: "form-control mb-2",
          placeholder: _ctx.$t('panel.incidents.author')
        }, null, 8, _hoisted_29), [
          [_vModelText, _ctx.newEntry.author]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newEntry.message) = $event)),
          class: "form-control mb-2",
          placeholder: _ctx.$t('panel.incidents.message')
        }, null, 8, _hoisted_30), [
          [_vModelText, _ctx.newEntry.message]
        ]),
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('panel.incidents.dateTime')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "datetime-local",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newEntry.createdAt) = $event)),
          class: "form-control mb-2"
        }, null, 512), [
          [_vModelText, _ctx.newEntry.createdAt]
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addEntry && _ctx.addEntry(...args)))
        }, _toDisplayString(_ctx.$t('panel.incidents.addEntry')), 1),
        _createElementVNode("button", {
          class: "btn btn-outline-secondary ms-2",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEntryModal = false))
        }, _toDisplayString(_ctx.$t('panel.incidents.cancel')), 1)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}